import { tableNodes } from "prosemirror-tables";
export function tableNodesSpec() {
    return tableNodes({
        tableGroup: "block",
        cellContent: "block+",
        cellAttributes: {
            background: {
                default: null,
                getFromDOM(dom) {
                    return dom.style.backgroundColor || null;
                },
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                setDOMAttr(value, attrs) {
                    if (value) {
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/restrict-plus-operands
                        attrs.style = (attrs.style || "") + `background-color: ${value};`;
                    }
                },
            },
        },
    });
}
